module.exports = __webpack_public_path__ + "media/svg/lv-6f6eaa7b.svg";